import { Modal } from "@material-ui/core";
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import useStyles from "./Popup.styles";
import { PropsType } from "./types";

function Popup({
  isPopupOpen,
   togglePopup,
    popupSize,
     closeIcon,
     modalChildren,
     onModalDismiss,
    }: PropsType['app'] & {togglePopup: any} ){
  const classes = useStyles({
    popupSize,
  });
  return(
       <Modal
      data-testid="popup-modal"
      open={isPopupOpen}
      className={classes.modal}
      onClose={() => {
        togglePopup({ isPopupOpen: false });
        onModalDismiss();
      }}
      // closeAfterTransitionBackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 1000,
      }}
    >
      <div
        className={`${classes.popup} ${popupSize}`}
      >
          <div style={{ position: 'relative' }}>
              <div
                className={classes.close}
                onClick={() => {
                  togglePopup({ isPopupOpen: false });
                  onModalDismiss();
                }}
              >
                <HighlightOffIcon fontSize="small" />
              </div>
          </div>
          {modalChildren}
      </div>
    </Modal>
  )
}

export default Popup;
